export default "__VITE_ASSET__bb53ed68__"